var _circle, _circle2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJaFoot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1165_3822",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 44,
    height: 44
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0003,
    cy: 23.9998,
    r: 21.2571,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1165_3822)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.9427,
    cy: 28.1141,
    r: 5.48571,
    fill: "#EDF4FC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "matrix(0.965926 0.258819 0.258819 -0.965926 19.7275 20.4502)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866026 17.7617 22.4824)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.2314,
    y: 22.3906,
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "rotate(105 16.2314 22.3906)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3635 23.8287L40.0957 26.2848H40.097C40.3732 27.2118 40.4918 28.1433 40.4491 29.0537C40.3655 30.8407 39.713 32.2223 38.5107 33.1589C35.9179 35.1783 31.7081 34.3623 31.4817 34.3164L31.3324 34.2876C26.305 33.3306 24.961 33.4213 22.9334 33.5611L11.7852 34.6209H11.7718C11.6531 34.626 11.5364 34.6286 11.4216 34.6286C9.46853 34.6286 8.0149 33.9084 7.09768 32.4853C6.58741 31.6937 6.39032 31.317 6.18493 30.1946C6.13901 29.9411 6.21427 29.6743 6.41009 29.401C6.94332 28.6566 8.51433 27.7194 10.3749 27.4468C13.0602 27.0541 13.7727 26.7636 18.1285 24.6651C21.8656 22.8647 24.0298 21.358 25.3648 19.6265C26.7247 17.8638 27.2943 15.7141 27.212 12.6567C27.2043 12.3751 27.4263 12.1402 27.7082 12.1325H27.7223C27.9978 12.1325 28.2242 12.3521 28.2319 12.6292C28.3212 15.9376 27.6859 18.2883 26.1729 20.2509C24.7346 22.1164 22.4613 23.7119 18.5718 25.5857C14.1554 27.7136 13.3358 28.0463 10.5229 28.458C8.64891 28.7326 7.34389 29.7356 7.19846 30.0599C7.37323 30.9984 7.51355 31.2461 7.95558 31.9318C8.72545 33.1263 9.95457 33.6728 11.7156 33.6013L22.8568 32.5428C26.3611 32.3021 28.415 32.6928 31.5231 33.2847L31.6826 33.3153C31.7215 33.323 35.6513 34.0948 37.8862 32.3513C38.8411 31.6062 39.3603 30.4806 39.4292 29.0058C39.4662 28.2103 39.3622 27.3931 39.1186 26.5766L38.3889 24.1288C38.3079 23.8843 37.2146 20.4482 36.9078 12.5302C36.8963 12.2487 37.1157 12.0112 37.3977 12.0003C37.6783 11.9901 37.9162 12.2085 37.9271 12.4907C38.1707 18.7902 38.9699 22.6508 39.3584 23.8121L39.3635 23.8287ZM32.5534 30.4097C32.2319 30.4097 31.8913 30.3893 31.5316 30.3484V30.3497C31.2516 30.3178 31.05 30.065 31.0819 29.7847C31.1138 29.5044 31.3664 29.3033 31.6464 29.3346C33.2557 29.5165 34.3604 29.2484 34.93 28.5365C35.8606 27.3727 35.1634 25.3143 35.1564 25.2939C35.0646 25.0277 35.2049 24.7365 35.4709 24.644C35.7369 24.5508 36.0271 24.6906 36.1202 24.9568C36.1572 25.0622 37.0113 27.5629 35.7298 29.1705C35.0729 29.9947 34.007 30.4097 32.5534 30.4097Z",
    fill: "#536479"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaFoot);
export default __webpack_public_path__ + "static/media/ja_foot.d7bbdbc4216662131d3aa896ba56ff46.svg";
export { ForwardRef as ReactComponent };